import React from "react";
import { useSelector } from "react-redux";
import tel from "../../assets/image/tel.png";
import warn from "../../assets/image/warn.png";
import { selectLogo } from "../../stores";

import "./index.css";

export const SupportCenter = () => {
  const logo = useSelector(selectLogo);

  return (
    <React.Fragment>
      <div className="bgSelf">
        <article className="weui-article">
          <section className="flex justify-center items-center py-6 px-10">
            <img className="max-w-full max-h-36" src={ logo.hotlineLogo || logo.logoPath } alt="" />
          </section>
          <section>
            <div className="flex flex-col w-3/4 user-auto">
              <span className="text-lg flex items-center">
                <img className="max-w-10 max-h-6 mr-3" src={ tel } alt="" />服务热线
              </span>
              <span className="font-medium text-xl mt-2">{ logo.hotline }</span>
            </div>
            <div className="flex items-center my-8">
              <img className="max-w-full max-h-10 mr-2" src={ warn } alt="" />
              <span className="text-sm">如果您在使用过程中遇到以下问题, 欢迎拨打服务热线与我们联系。</span>
            </div>
            <div className="w-3/4 user-auto">
              <ul className="textBlack text-sm">
                {
                  logo.hotlineInfos?.map((i, idx) => <li className="list-none font-semibold" key={ idx }>{ i }</li>)
                }
              </ul>
            </div>
          </section>
        </article>
      </div>
    </React.Fragment>
  );
};
